import {
	CalculatorDefaultResponse,
	CalculatorFormatedSummaries,
	CalculatorRequest,
} from '../../../hooks/calculator/useCalculator';

export enum FilterTypes {
	TODOS = 'Todos',
	LIFESTYLE = 'lifestyle',
	PROFESIONAL = 'profesional',
	COMBUSTION = 'Combustión',
	HIBRIDOS_ENCHUFABLES = 'Híbridos enchufables',
	ELECTRICOS = 'Eléctricos',
}

export enum PeriodicidadType {
	PAGO_UNICO = 'pago-unico',
	MENSUAL = 'mensual',
	ANUAL = 'anual',
	DIARIO = 'dia',
}

export enum FinanciacionType {
	MY_WAY = 'my-way',
	MY_WAY_SERVICE = 'my-way-service',
	RENTING = 'renting',
	MY_RENTING = 'my-renting',
	FLEX_RENTING = 'flex-renting',
	LEASING = 'leasing',
}

export enum DetalleFinanciacionType {
	ENTRADA = 'entrada',
	CUOTAS = 'cuotas',
	CUOTA_FINAL = 'cuota_final',
	TAE = 'TAE',
}

export interface Carline {
	id: number;
	code: number;
	codePreviousYear: number;
	name: string;
	text: string;
	title: string;
	titulo: string;
	brand: string;
	brandShare: boolean;
	activo: boolean;
	activoVO: boolean;
	activoOffers: boolean;
	prioridadOffers: number;
	activoMatch: boolean;
	activoStock: boolean;
	activoMeasurements: boolean;
	activoOcasion?: boolean;
	nuevo: boolean;
	legalConsumos: string;
	showroomURL: string;
	plazas: number;
	capacidadMaletero: number[];
	medidas: {
		alto: number;
		ancho: number;
		largo: number;
	};
	colores: {
		exterior: Color | null;
		interior: Color | null;
	};
	categorias: {
		compacto: boolean;
		berlina: boolean;
		suv: boolean;
		familiar: boolean;
	};
	formularios: {
		testDrive: boolean;
		presupuesto: boolean;
		masInformacion: boolean;
		prospect: boolean;
		callMe: boolean;
	};
	ocasion?: {
		precio: string | number;
		dwaURL: string;
		legal: string;
	};
	campaign: {
		activo: boolean;
		salesforce: boolean;
	};
	mediaAssets: MediaAssets;
}

export interface CarlineWithOfertas extends Carline {
	ofertas: Oferta[];
	ofertasCampaign?: OfertaCampaign[];
}

export interface Color {
	nombre: string;
	codigo: string;
	hexadecimal: string;
	invertido: boolean;
	atrevido: boolean;
	elegante: boolean;
}

export interface MediaAssets {
	'CarSideview'?: string;
	'CarStage3-4'?: string;
	'FormsSuccessCarStage3-4'?: string;
	'D6MOFASideview'?: string;
	'D6MOFA34FrontPC'?: string;
	'D6MOFASidePC'?: string;
	'D6MainStageExterior'?: string;
	'FallbackSideview'?: string;
	'CarStage34'?: string;
	'D6Explore1'?: string;
	'D6Explore2'?: string;
	'FormsCarSideviewSummary'?: string;
	'ExploreCar1'?: string;
	'D6Turntable1'?: string;

	//Comerciales:
	'D6Explore1Alpha'?: string;
	'D6Explore2Alpha'?: string;
	'D6MOFA34FrontCV'?: string;
	'D6MOFASideCV'?: string;
}

export interface Oferta {
	id: number;
	activo: number;
	prioridad: number;
	anchor: string;
	route: string;
	gama: string;
	titulo: string;
	descripcion: string;
	configuracion: Configuracion;
	datosEconomicos: DatoEconomico[];
	carline?: {
		id: number;
		nuevo: number;
		code: number;
		name: string;
		title: string;
		text: string;
		salesgroup: {
			id: number;
			code: number;
			name: string;
			title: string;
			text: string;
			year: number;
			codePreviousYear: string;
			colores: Color;
			model: {
				id: number;
				activo: number;
				code: string;
				name: string;
				descripcion: string;
			};
		};
	};
	promociones: Promocion[];
	galeria: string[];

	// dco: Dco;
	// flexRenting: boolean;
	// next: boolean;
	// pff: {
	// 	accessory: number;
	// 	basic: number;
	// 	campaign: number;
	// 	exterior: number;
	// 	package: number;
	// };
	calculatedFinance: {
		rawResponse: CalculatorDefaultResponse['rawResponse'] | undefined;
		summaries: CalculatorFormatedSummaries | undefined;
	};
}

export interface DatoEconomico {
	id: number;
	prioridad: number;
	modalidad: string;
	precio: number;
	periodicidad: PeriodicidadType;
	plazos: number;
	tipoFinanciacion: FinanciacionType;
	pagoEntrada: number | null;
	pagoFinal: number | null;
	costeTotal: number | null;
	ivaIncluido: boolean;
	tin: number | null;
	tae: number | null;
	info: number | null;
	legal: string;
}

export interface Configuracion {
	etiquetaDGT?: string;
	marketingCode: string;
	motorizacion: {
		name: string;
		code: string;
		combustible: string;
		fourMotion: boolean;
		dsg: boolean;
		tiptronic: boolean;
		cambio: string;
		emisiones: number;
		consumo: number;
	};
	colores: {
		exterior: Color;
		interior: Color;
	};
	mediaAssets: MediaAssets;
	equipamientos?: Equipamientos;
}

export interface FinanceData {
	request: CalculatorRequest | string | undefined;
	selectedOferta: Oferta | undefined;
	dataFromOfertasLayer?: boolean;
}

export interface Equipamientos {
	serie: Equipamiento[];
	destacados: Equipamiento[];
}

export interface Promocion {
	name: string;
	text: string;
	descripcion: string;
	cta: { label: string; url: string };
}

export interface Equipamiento {
	equipamiento: {
		titulo: string;
		descripcion: string;
		icono: number;
	};
}

export interface OfertaCampaign {
	name: string;
	titulo: string;
	descripcion: string;
	cta: { label: string; url: string };
	logo: { url: string };
}

export interface Dco {
	activo: boolean;
	modalidad: string;
	legal: string;
	cuotaModalidad: string;
	cuotaLegal: string;
	precioModalidad: string;
	precioLegal: string;
}

export interface filtersFaContentOfertas {
	carlines: string[];
	motorizaciones: string[];
	gama: string[];
	financiacion: string[];
}
